import React from "react";
import coach1 from "../Assets/Coaches/coach1.png";
import coach2 from "../Assets/Coaches/coach2.jpg";
import coach3 from "../Assets/Coaches/coach3.png";
import coach4 from "../Assets/Coaches/coach4.png";
import coach5 from "../Assets/Coaches/coach5.png";
import coach6 from "../Assets/Coaches/coach6.png";
import coach7 from "../Assets/Coaches/coach7.png";
import coach8 from "../Assets/Coaches/coach8.png";

const coaches = [
  {
    name: "Chandra Thompson ",
    years: "",
    title: "Head Coach",
    image: coach1,
    bio: " ",
  },
  {
    name: "Pat Hicky",
    years: "",
    title: "Head Coach",
    image: coach2,
    bio: "",
  },
  {
    name: "Mark Papas",
    years: "",
    title: "Head Coach",
    image: coach3,
    bio: "",
  },
  {
    name: "Nora Fille",
    years: "",
    title: "Assistant Coach",
    image: coach4,
    bio: "",
  },
  {
    name: "Bradley Reckinger",
    years: "",
    title: "Assistant Coach",
    image: coach5,
    bio: "",
  },
   {
    name: "Nick Reckinger",
    years: "",
    title: "Assistant Coach",
    image: coach6,
    bio: "",
  },
  {
    name: "Anthony LaMonica",
    years: "",
    title: "Assistant Coach",
    image: coach7,
    bio: "",
  },
  {
    name: "Jackson Pizzo",
    years: "",
    title: "Assistant Coach",
    image: coach8,
    bio: "",
  },
 
];

function Coaches() {
  return (
    <div className="centered-page">
    <div style={{ padding: '2rem 2rem',  margin: '1rem 1rem' }}>
      <h2 style={{ textAlign: "center" }}>Coaching Staff</h2>
      <p>Without these individuals, no athlete would reach their full potential. These dedicated coaches provide guidance, support, and expertise to help our rowers excel both on and off the water.</p>
      <p>They sacrifice their time for the love of the sport and the young people they help mentor and develop.</p>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "2rem",
          marginTop: "2rem",
        }}
      >
        {coaches.map((coach, idx) => (
          <div
            key={idx}
            style={{
              background: "#f8f9fc",
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(22,22,116,0.06)",
              padding: "1.5rem",
              textAlign: "center",
            }}
          >
            <img
              src={coach.image}
              alt={coach.name}
              style={{
                width: "200px",
                height: "200px",
                objectFit: "cover",
                borderRadius: "50%",
                marginBottom: "1rem",
                background: "#e0e4f7",
              }}
            />
            <div style={{ fontWeight: "bold", fontSize: "1.1rem", marginBottom: "0.3rem" }}>
              {coach.name}
            </div>
                 <div style={{ fontWeight: "bold", fontSize: "1.1rem", marginBottom: "0.3rem" }}>
              {coach.title}
            </div>
            <div style={{ color: "#162278", fontWeight: "bold", marginBottom: "0.5rem" }}>
              {coach.years}
            </div>
            <div style={{ fontSize: "0.98rem", color: "#333" }}>{coach.bio}</div>
          </div>
        ))}
      </div>
    </div>
       </div>
  );
}

export default Coaches;